import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import { configLoad, socketUnsubscribe } from '../../../../redux/actions'

const LoadComponents = ({ config, socket }) => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (!config.init) {
      let c = searchParams.get('c') || window.runConfig.customer
      if (c) {
        window.localStorage.setItem('c', c)
      } else {
        c = window.localStorage.getItem('c')
      }

      dispatch(configLoad(c))
    }
  }, [dispatch, config.init, config.loading, searchParams])

  useEffect(() => {
    return () => {
      if (socket.init && socket.subscriptions.length > 0) {
        socket.subscriptions.forEach((roomName) =>
          dispatch(socketUnsubscribe(roomName))
        )
      }
    }
  }, [dispatch, socket.init, socket.subscriptions])

  return <React.Fragment />
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {})(LoadComponents)
